import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { ITodo } from '@clickersphere/core/entities/ITodo';
import TodoService, {
  ITodoFilters,
} from '@clickersphere/core/services/TodoService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const TODOS_QUERY_KEY = 'todos';

export type TodoQueryData = WithQueryStatus<ITodo>;

export function useTodos(filters?: ITodoFilters) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const filterKey = filters ? JSON.stringify(filters) : 'all';

  const {
    data: todos,
    isSuccess: isTodosSuccess,
    isFetching: isTodosFetching,
    isLoading: isTodosLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey([TODOS_QUERY_KEY, filterKey]),
    queryFn: async () => {
      const todos = await TodoService.getAll(filters);
      return todos as TodoQueryData[];
    },
  });

  return {
    todos,
    isTodosSuccess,
    isTodosFetching,
    isTodosLoading,
  };
}
